var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceleaseReplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10492",
    "data-name": "Group 10492",
    transform: "translate(-156 -466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10433",
    "data-name": "Group 10433",
    transform: "translate(-519.488 127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10516",
    "data-name": "Group 10516",
    transform: "translate(691.489 358.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_House_contract_-_Flaticon-2_1_",
    "data-name": "Search results for House contract - Flaticon-2 (1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10137",
    "data-name": "Path 10137",
    d: "M49.137,5.258H47.5V3.623a1.537,1.537,0,0,0-1.535-1.535H23.577a2.329,2.329,0,0,0-4.414,0H14.232A1.537,1.537,0,0,0,12.7,3.623v23.7L3.975,18.6A2.329,2.329,0,1,0,.682,21.891l.6.6-.6.6a2.329,2.329,0,0,0,0,3.294L5.171,30.87a.742.742,0,0,0,1.042-1.042l-4.479-4.5a.846.846,0,0,1,0-1.194l.6-.6L12.7,33.9V44.872a1.537,1.537,0,0,0,1.535,1.535h1.637v1.637A1.537,1.537,0,0,0,17.4,49.58H42.916a2.315,2.315,0,0,0,1.648-.683l5.417-5.417a2.315,2.315,0,0,0,.683-1.648V6.794a1.537,1.537,0,0,0-1.535-1.535ZM14.179,3.623a.05.05,0,0,1,.05-.05h7.983v1.69H17.4A1.537,1.537,0,0,0,15.869,6.8V30.5l-1.69-1.69ZM19.761,37.67h0a.833.833,0,0,1-1.19,0l-.6-.6,1.194-1.194.6.6a.833.833,0,0,1,0,1.187Zm-2.844-1.644-3.44-3.446,1.194-1.194,3.437,3.437ZM1.732,20.841a.844.844,0,0,1,1.185-1.194l.6.6L2.323,21.441Zm2.844.454,9.048,9.048-1.194,1.194L3.38,22.491ZM17.354,48.045V40.914a.743.743,0,0,0-1.485,0v4.019H14.232a.052.052,0,0,1-.05-.05V35.389l3.333,3.333a2.329,2.329,0,0,0,2.681.437l.681.681A.742.742,0,1,0,21.919,38.8l-.681-.681a2.327,2.327,0,0,0-.437-2.681l-3.448-3.462V6.794a.052.052,0,0,1,.052-.046h4.81V9.173a.845.845,0,0,1-1.69,0,.743.743,0,0,0-1.485,0,2.329,2.329,0,0,0,4.658,0V6.748h.844a.743.743,0,0,0,0-1.485H23.7V3.569H45.964a.05.05,0,0,1,.05.054V5.26H27.708a.743.743,0,0,0,0,1.485H49.137a.05.05,0,0,1,.05.05V41.747H44.375a1.537,1.537,0,0,0-1.535,1.535v4.81H17.4a.05.05,0,0,1-.05-.05Zm26.972-1v-3.76a.05.05,0,0,1,.05-.05h3.762Zm0,0",
    transform: "translate(0.001 -0.502)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10138",
    "data-name": "Path 10138",
    d: "M337.42,126.98a.737.737,0,0,0,.525-.208l.321-.319v3.762a.742.742,0,0,0,.742.742h6.346a.742.742,0,0,0,.742-.742v-3.773l.321.319a.742.742,0,1,0,1.042-1.042l-4.76-4.76a.742.742,0,0,0-1.042,0l-4.76,4.76a.742.742,0,0,0,.525,1.267Zm4.76-4.452,2.431,2.431v4.5h-4.862v-4.5Zm0,0",
    transform: "translate(-303.357 -108.838)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10139",
    "data-name": "Path 10139",
    d: "M249.242,130.243H254.8a.743.743,0,1,0,0-1.485h-5.554a.743.743,0,0,0,0,1.485Zm0,0",
    transform: "translate(-223.904 -116.068)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10140",
    "data-name": "Path 10140",
    d: "M225.2,170.321h7.933a.743.743,0,0,0,0-1.485H225.2a.743.743,0,1,0,0,1.485Zm0,0",
    transform: "translate(-202.238 -152.18)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10141",
    "data-name": "Path 10141",
    d: "M225.2,210.4h7.933a.743.743,0,0,0,0-1.485H225.2a.743.743,0,1,0,0,1.485Zm0,0",
    transform: "translate(-202.238 -188.295)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10142",
    "data-name": "Path 10142",
    d: "M225.2,258.5H245.82a.743.743,0,0,0,0-1.485H225.2a.743.743,0,0,0,0,1.485Zm0,0",
    transform: "translate(-202.238 -231.631)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10143",
    "data-name": "Path 10143",
    d: "M225.2,298.579H245.82a.743.743,0,0,0,0-1.485H225.2a.743.743,0,0,0,0,1.485Zm0,0",
    transform: "translate(-202.238 -267.744)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10144",
    "data-name": "Path 10144",
    d: "M225.195,338.659h20.625a.742.742,0,1,0,0-1.483H225.195a.742.742,0,0,0,0,1.483Zm0,0",
    transform: "translate(-202.238 -303.86)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10145",
    "data-name": "Path 10145",
    d: "M232.252,380.428h-2.823a.834.834,0,0,1-.8-.577l-.431-1.3a.742.742,0,0,0-1.3-.208l-1.383,1.846-.467-2.34a.742.742,0,0,0-1.321-.3l-4.283,5.712a.844.844,0,0,1-1.521-.506v-.794a.743.743,0,1,0-1.485,0v.794a2.329,2.329,0,0,0,4.192,1.4l3.287-4.375.469,2.34a.742.742,0,0,0,1.321.3l1.531-2.04a2.327,2.327,0,0,0,2.194,1.544h2.823a.743.743,0,0,0,0-1.485Zm0,0",
    transform: "translate(-195.014 -339.973)",
    fill: "#00641f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Renew_-_Flaticon-2_1_",
    "data-name": "Search results for Renew - Flaticon-2 (1)",
    transform: "translate(156 464.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10490",
    "data-name": "Group 10490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10489",
    "data-name": "Group 10489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10488",
    "data-name": "Group 10488",
    transform: "translate(0 1.596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10051",
    "data-name": "Path 10051",
    d: "M123.667,247.467a1.5,1.5,0,0,0-1.5,1.5,41.982,41.982,0,0,1-74.145,27h8.144a1.5,1.5,0,1,0,0-3h-12a1.5,1.5,0,0,0-1.5,1.5v12a1.5,1.5,0,0,0,3,0v-8.639a44.982,44.982,0,0,0,79.5-28.861A1.5,1.5,0,0,0,123.667,247.467Z",
    transform: "translate(-35.167 -203.967)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10052",
    "data-name": "Path 10052",
    d: "M45,3A42.145,42.145,0,0,1,77.145,18H69a1.5,1.5,0,0,0,0,3H81a1.5,1.5,0,0,0,1.5-1.5V7.5a1.5,1.5,0,0,0-3,0v8.639A44.982,44.982,0,0,0,0,45a1.5,1.5,0,0,0,3,0A42.047,42.047,0,0,1,45,3Z",
    fill: "#00641f"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceleaseReplace);
export default __webpack_public_path__ + "static/media/financeleaseReplace.1ab85ab16850699b103350e2dc9e7f82.svg";
export { ForwardRef as ReactComponent };